import React from 'react';
import { PROJECT_TYPES } from '../../../services/projectsAPI';
import { PROJECT_CATEGORIES } from '../constants';

function BasicInfoStep({
  formData,
  errors,
  permissionTags,
  hasWildcardAccess,
  userProfile,
  getVisibleTags,
  onChange,
}) {
  // 取得使用者可見的標籤
  const visibleTags = getVisibleTags ? getVisibleTags() : [];
  return (
    <div className="space-y-6 fade-in">
      <div>
        <h2 className="text-2xl font-bold text-gray-900 mb-6">基本資訊</h2>
      </div>

      {/* 專案名稱 */}
      <div>
        <label className="block text-sm font-medium text-gray-700 mb-2">
          專案名稱 <span className="text-red-500">*</span>
        </label>
        <input
          type="text"
          value={formData.name}
          onChange={(e) => onChange('name', e.target.value)}
          className={`w-full px-4 py-3 border rounded-lg focus:outline-none focus:ring-2 focus:ring-purple-500 ${
            errors.name ? 'border-red-500' : 'border-gray-300'
          }`}
          placeholder="例: 2025 Q1 供應商評估專案"
        />
        {errors.name && (
          <p className="mt-1 text-sm text-red-600">{errors.name}</p>
        )}
      </div>

      {/* 專案代碼 */}
      <div>
        <label className="block text-sm font-medium text-gray-700 mb-2">
          專案代碼（留空自動生成）
        </label>
        <input
          type="text"
          value={formData.code}
          onChange={(e) => onChange('code', e.target.value)}
          className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-purple-500"
          placeholder="例: 2025-Q1-ABCD"
        />
        <p className="mt-1 text-xs text-gray-500">留空系統將自動生成唯一代碼</p>
      </div>

      {/* 專案描述 */}
      <div>
        <label className="block text-sm font-medium text-gray-700 mb-2">
          專案描述
        </label>
        <textarea
          value={formData.description}
          onChange={(e) => onChange('description', e.target.value)}
          rows={4}
          className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-purple-500"
          placeholder="描述此專案的目的和範圍..."
        />
      </div>

      {/* 專案類型 */}
      <div>
        <label className="block text-sm font-medium text-gray-700 mb-2">
          專案類型
        </label>
        <select
          value={formData.project_type}
          onChange={(e) => onChange('project_type', e.target.value)}
          className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-purple-500"
        >
          {PROJECT_TYPES.map((type) => (
            <option key={type.value} value={type.value}>
              {type.label}
            </option>
          ))}
        </select>
      </div>

      {/* 專案分類 */}
      <div>
        <label className="block text-sm font-medium text-gray-700 mb-2">
          專案分類
        </label>
        <select
          value={formData.category}
          onChange={(e) => onChange('category', e.target.value)}
          className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-purple-500"
        >
          {PROJECT_CATEGORIES.map((cat) => (
            <option key={cat.value} value={cat.value}>
              {cat.label}
            </option>
          ))}
        </select>
      </div>

      {/* 權限標籤（多選） */}
      {permissionTags.length > 0 && (
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">
            權限標籤 <span className="text-red-500">*</span>
          </label>
          <div className="flex flex-wrap gap-2">
            {permissionTags
              .filter(tag => {
                if (hasWildcardAccess()) return true;
                if (visibleTags.includes(tag.name)) return true;
                if (formData.access_tags?.includes(tag.name)) return true;
                return false;
              })
              .map(tag => {
                const isSelected = formData.access_tags?.includes(tag.name);
                return (
                  <button
                    key={tag.id}
                    type="button"
                    onClick={() => {
                      const current = formData.access_tags || [];
                      const updated = isSelected
                        ? current.filter(t => t !== tag.name)
                        : [...current, tag.name];
                      onChange('access_tags', updated);
                    }}
                    className={`px-3 py-1.5 rounded-full text-sm font-medium transition ${
                      isSelected
                        ? 'bg-purple-600 text-white'
                        : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
                    }`}
                    style={isSelected && tag.color ? { backgroundColor: tag.color } : {}}
                  >
                    {tag.name}
                  </button>
                );
              })}
          </div>
          <p className="mt-1 text-xs text-gray-500">
            決定哪些使用者可以存取此專案（可多選）
          </p>
          {formData.access_tags?.length > 0 && (
            <p className="text-xs text-purple-600 mt-1">
              已選擇 {formData.access_tags.length} 個標籤
            </p>
          )}
          {errors.access_tags && (
            <p className="mt-1 text-sm text-red-600">{errors.access_tags}</p>
          )}
        </div>
      )}
    </div>
  );
}

export default BasicInfoStep;
